import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import "./WelcomePage.css";
import AppFooter from "./AppFooter";
import { clearToken } from "./authStorage";

function WorkspaceFaqPage() {
  const [contactOpen, setContactOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Can I upload a folder of PDFs?",
      answer: "Folders are not supported. Please use one PDF at a time for the best result."
    },
    {
      question: "How long does statement conversion usually take?",
      answer: "Conversion time depends on page count and scan quality."
    },
    {
      question: "What kind of PDF gives the best result?",
      answer: "Original exported PDFs usually perform best, followed by clear upright scans with full page content visible."
    },
    {
      question: "How is my data stored?",
      answer: "Bank statements and generated Excel files are stored temporarily in secure cloud storage for up to 24 hours so you can download the output from your account. After that, they are automatically deleted."
    },
    {
      question: "Can I upload scanned bank statements?",
      answer: "Yes, but clear upright scans with sharp text usually give better extraction results than low-quality or tilted scans."
    },
    {
      question: "What should I do if the Excel output does not look right?",
      answer: "Please contact support with a short description of the issue and, if possible, a redacted sample so we can review the statement format."
    },
    {
      question: "Can I upload statements from different banks together?",
      answer: "For the best result, keep different statements and bank formats in separate PDF files instead of combining them together."
    },
  ];

  const handleLogout = () => {
    clearToken();
    window.location.replace("/login");
  };

  return (
    <div className="app-container welcome-page">
      <main className="welcome-workspace">
        <aside className="welcome-sidebar">
          <div className="welcome-sidebar-brand">
            <Link to="/welcome" className="welcome-sidebar-brand-link">
              <span className="welcome-sidebar-brand-mark" aria-hidden="true" />
              <span className="welcome-sidebar-brand-text">StatementIQ</span>
            </Link>
          </div>

          <div className="welcome-sidebar-nav">
            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Workspace</p>
              <Link to="/welcome" className="welcome-sidebar-link">
                Convert Statements
              </Link>
            </div>

            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Help &amp; Support</p>
              <Link to="/account" className="welcome-sidebar-link">
                Account
              </Link>
              <Link to="/workspace-faq" className="welcome-sidebar-link active">
                FAQ
              </Link>
            </div>

            <div className="welcome-sidebar-group">
              <p className="welcome-sidebar-title">Legal</p>
              <Link to="/privacy" className="welcome-sidebar-link">
                Privacy Policy
              </Link>
              <Link to="/terms" className="welcome-sidebar-link">
                Terms of Service
              </Link>
            </div>
          </div>

          <div className="welcome-sidebar-support-card">
            <strong>Need help?</strong>
            <p>Our support team is here to assist you.</p>
            <button
              type="button"
              className="welcome-sidebar-support-button"
              onClick={() => setContactOpen(true)}
            >
              Contact Support
            </button>
          </div>
          <button
            type="button"
            className="welcome-sidebar-link welcome-sidebar-button welcome-sidebar-logout"
            onClick={handleLogout}
          >
            Logout
          </button>
        </aside>

        <section className="welcome-content">
          <div className="welcome-body-grid">
            <div className="welcome-main-panel workspace-scroll-panel">
              <div className="welcome-heading-row">
                <div>
                  <h1>Frequently Asked Questions</h1>
                  <p className="welcome-subtitle workspace-faq-subtitle">
                    Quick answers about uploading statements, conversion quality, and common workflow questions.
                  </p>
                </div>
              </div>

              <div className="workspace-faq-list">
                {faqs.map((faq, index) => {
                  const isOpen = openIndex === index;
                  return (
                    <article key={faq.question} className={`workspace-faq-item ${isOpen ? "is-open" : ""}`}>
                      <button
                        type="button"
                        className="workspace-faq-question"
                        onClick={() => setOpenIndex(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                      >
                        <span>{faq.question}</span>
                        <span className="workspace-faq-icon">{isOpen ? "−" : "+"}</span>
                      </button>
                      {isOpen && <div className="workspace-faq-answer">{faq.answer}</div>}
                    </article>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </main>

      {contactOpen && (
        <div className="welcome-tips-popup-overlay" onClick={() => setContactOpen(false)}>
          <div className="welcome-tips-popup" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="welcome-tips-close"
              aria-label="Close contact popup"
              onClick={() => setContactOpen(false)}
            >
              ×
            </button>

            <div className="welcome-tips-header">
              <h2>Contact Us</h2>
            </div>

            <div className="welcome-contact-body">
              <p>
                If you need help with bank statement uploads, conversion issues, or account access,
                please contact our support team.
              </p>
              <p>
                Include your name, company, and a short summary of the issue so we can help quickly.
              </p>
              <p>
                <a href="mailto:support@statementiq.co.uk">support@statementiq.co.uk</a>
              </p>
            </div>
          </div>
        </div>
      )}

      <AppFooter />
    </div>
  );
}

export default WorkspaceFaqPage;
